import { Routes } from '@angular/router';
import { EmployeesListComponent } from './employees-list/employees-list.component';
import { EmployeeDetailComponent } from './employee-detail/employee-detail.component';
import { SuccessionPlanComponent } from './succession-plan/succession-plan.component';
import { PerformanceReviewComponent } from './performance-review/performance-review.component';

export const routes: Routes = [
  {
    path: 'employees',
    component: EmployeesListComponent,
  },
  {
    path: 'employee/:id',
    component: EmployeeDetailComponent,
  },
  {
    path: 'employee/:id/review',
    component: PerformanceReviewComponent,
  },
  {
    path: 'succession-plan',
    component: SuccessionPlanComponent,
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
